import { render, staticRenderFns } from "./addDataForm1.vue?vue&type=template&id=a879bb4c&scoped=true&"
import script from "./addDataForm1.vue?vue&type=script&lang=js&"
export * from "./addDataForm1.vue?vue&type=script&lang=js&"
import style0 from "./addDataForm1.vue?vue&type=style&index=0&id=a879bb4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a879bb4c",
  null
  
)

export default component.exports